var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1641_245)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.96875 8.09625C6.04875 10.2188 7.785 11.955 9.91125 13.035L11.5612 11.3813C11.7675 11.175 12.0638 11.115 12.3225 11.1975C13.1625 11.475 14.0662 11.625 15 11.625C15.4163 11.625 15.75 11.9587 15.75 12.375V15C15.75 15.4163 15.4163 15.75 15 15.75C7.9575 15.75 2.25 10.0425 2.25 3C2.25 2.58375 2.5875 2.25 3 2.25H5.625C6.04125 2.25 6.375 2.58375 6.375 3C6.375 3.93375 6.525 4.8375 6.8025 5.6775C6.885 5.93625 6.825 6.2325 6.61875 6.43875L4.96875 8.09625Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1641_245"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.5ac041863eeb39dd5aa1e8af63fa6880.svg";
export { ForwardRef as ReactComponent };